"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var BreadcrumbContainer = styled_components_1.default.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var BreadcrumbList = styled_components_1.default.ol(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  @media (max-width: 600px) {\n    display: none;\n  }\n"], ["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  @media (max-width: 600px) {\n    display: none;\n  }\n"])));
var BreadcrumbsContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(BreadcrumbContainer, { "aria-label": "Breadcrumb", "data-testid": "breadcrumbs-container" },
        react_1.default.createElement(BreadcrumbList, null, children)));
};
exports.default = BreadcrumbsContainer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=BreadcrumbsContainer.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Breadcrumbs/BreadcrumbsContainer/BreadcrumbsContainer.js
// module id = 2129
// module chunks = 18 19